<template>
    <div class="guide-search-wrap p-r m-0-a" :style="{backgroundImage: 'url('+info.icon+');background-size:100% 100%;'}">
        <input type="text" class="p-a" v-model="searchWord" placeholder="Enter Keyword to search">
        <a href="javascript:;" class="search d-i-b p-a" @click="search"></a>
    </div>
</template>
<style scoped lang='less'>
    .guide-search-wrap {
        width: 7.6rem;
        height: .8rem;
        margin-top: .4rem;
        margin-bottom: .4rem;
        input {
            width: 5.1rem;
            height: .6rem;
            margin-top: -0.3rem;
            top: 50%;
            border: none;
            font-size: .32rem;
            left: 0.5rem;
        }
        .search{
            width: 1.733333rem;
            height: .8rem;
            top: 0;
            right: 0;
        }
    }
     ::-webkit-input-placeholder {
        /* WebKit browsers */
        color: #ccc;
    }
     :-moz-placeholder {
        /* Mozilla Firefox 4 to 18 */
        color: #ccc;
    }
     ::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        color: #ccc;
    }
     :-ms-input-placeholder {
        /* Internet Explorer 10+ */
        color: #ccc;
    }
</style>
<script>
    export default {
        props: ['info'],
        data() {
            return {
                searchWord: ''
            }
        },
        methods: {
            search() {
                if (this.searchWord) {
                    this.$emit("search", this.searchWord);
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// client/smsgz/components/guide/guide-search.vue